import { defineMessages } from 'react-intl';

export const validationMessages = defineMessages({
  required: {
    id: 'validation-messages.field.required',
    defaultMessage: 'Value is required.',
  },
  tooShort: {
    id: 'validation-messages.field.too-short',
    defaultMessage: 'Too short. Expected more than {value}.',
  },
  tooLong: {
    id: 'validation-messages.field.too-long',
    defaultMessage: 'Too long. Expected less than {value}.',
  },
  invalidEmail: {
    id: 'validation-messages.field.invalid-email',
    defaultMessage: 'Invalid email',
  },
  passwordsNoMatch: {
    id: 'validation-messages.field.password-no-match',
    defaultMessage: "Passwords don't match",
  },
  fieldMustBeChecked: {
    id: 'validation-messages.field.checkbox-checked',
    defaultMessage: 'Field must be checked',
  },
});

export const notificationMessages = defineMessages({
  success: {
    id: 'noti.success',
    defaultMessage: 'Success!',
  },
});

export const validateEmails = (values, formatMessage) => {
  let error = null;

  if (values && values.length > 0) {
    values.forEach((val) => {
      if (!(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,6}$/i.test(val))) {
        error = formatMessage(validationMessages.invalidEmail);
      }
    });
  }

  return error;
};
